import http from '@/http/http'
import apiCfg from "../../config"
export default {
    //查询客户信息
    getUser: function () {
        return http.get(apiCfg.portalApi+"/user");
    },
    //登录
    submitLogin: function (params) {
        return http.post(apiCfg.portalApi+"/login", params);
    },
    //登录
    wxLogin: function (params) {
        return http.get(apiCfg.portalApi+"/wxlogin", params);
    },
    //添加客户的供应商/发货人/进口商
    addUser: function (params) {
        return http.post(apiCfg.portalApi+"/user/userInfo/add", params)
    },
    //查询客户的供应商/发货人/进口商
    queryUser: function (params) {
        return http.get(apiCfg.portalApi+"/user/userInfo/list", params)
    },
    // ==================== 发票抬头自助维护（20261102 一期） ====================
    //查询我的发票抬头
    queryInvoiceTitle: function (params) {
        return http.get(apiCfg.portalApi+"/user/invoiceTitle/list", params)
    },
    //新增发票抬头
    addInvoiceTitle: function (params) {
        return http.post(apiCfg.portalApi+"/user/invoiceTitle/add", params)
    },
    //修改发票抬头
    updateInvoiceTitle: function (params) {
        return http.post(apiCfg.portalApi+"/user/invoiceTitle/update", params)
    },
    //删除发票抬头
    delInvoiceTitle: function (id) {
        return http.post(apiCfg.portalApi+"/user/invoiceTitle/del", { id })
    },
    //修改客户的供应商/发货人/进口商
    modifyUser: function (params) {
        return http.post(apiCfg.portalApi+"/user/userInfo/update", params)
    },
    //添加产品
    addProduct: function (params) {
        return http.post(apiCfg.portalApi+"/user/product/add", params)
    },
    //查询产品
    queryProduct: function (params) {
        return http.get(apiCfg.portalApi+"/user/product/list", params)
    },
    //我的库存（领星同步摘要）
    queryInventory: function (params) {
        return http.get(apiCfg.portalApi+"/user/inventory/list", params)
    },
    queryInventoryDashboard: function (params) {
        return http.get(apiCfg.portalApi+"/user/inventory/dashboard", params)
    },
    queryOutbound: function (params) {
        return http.get(apiCfg.portalApi+"/user/outbound/list", params)
    },
    queryInbound: function (params) {
        return http.get(apiCfg.portalApi+"/user/inbound/list", params)
    },
    queryStockAge: function (params) {
        return http.get(apiCfg.portalApi+"/user/stockAge/list", params)
    },
    //一件代发仓（管理端代发仓配置·启用）
    listDaifaWarehouse: function (params) {
        return http.get(apiCfg.portalApi+"/user/daifa/warehouse/list", params)
    },
    getDaifaIntegration: function () {
        return http.get(apiCfg.portalApi + "/user/daifa/integration")
    },
    saveDaifaIntegration: function (params) {
        return http.post(apiCfg.portalApi + "/user/daifa/integration/save", params)
    },
    testDaifaIntegration: function () {
        return http.post(apiCfg.portalApi + "/user/daifa/integration/test")
    },
    saveDaifaShop: function (params) {
        return http.post(apiCfg.portalApi + "/user/daifa/shop/save", params)
    },
    delDaifaShop: function (id) {
        return http.post(apiCfg.portalApi + "/user/daifa/shop/del", null, { params: { id } })
    },
    //删除产品
    delProduct: function (data, params) {
        return http.post(apiCfg.portalApi+"/user/product/del", data, params)
    },
    //修改产品
    updateProdct: function (params) {
        return http.post(apiCfg.portalApi+"/user/product/update", params)
    },
    //修改客户信息
    updateAccount: function (params) {
        return http.post(apiCfg.portalApi+"/user/update", params)
    },
    //订单分页列表
    orderList: function (params) {
        return http.get(apiCfg.portalApi+"/order/list", params)
    },
    //GET /portal/api/1.0/order/count查询订单数量
    orderListCount: function (params) {
        return http.get(apiCfg.portalApi+"/order/count", params)
    },
    //查询订单详情
    findOrder: function ( params) {
        return http.get(apiCfg.portalApi+'/order/find', params)
    },
    //查询消息
    queryMsg: function (params) {
        return http.get(apiCfg.portalApi+"/user/msg", params)
    },
    //客户待办列表
    customerTodoList: function () {
        return http.get(apiCfg.portalApi+"/user/customerTodo/list")
    },
    //办结客户待办
    customerTodoComplete: function (params) {
        return http.post(apiCfg.portalApi+"/user/customerTodo/complete", params)
    },
    //用户余额
    balanceM() {
        return http.get(apiCfg.portalApi+"/user/center/balance")
    },
    //业务统计
    staticsM() {
        return http.get(apiCfg.portalApi+"/user/center/order_statistics")
    },
    //问题件
    abnormal() {
        return http.get(apiCfg.portalApi+"/user/center/abnormal_order_list")
    },
    //文件下载
    orderFile() {
        return http.get(apiCfg.portalApi+"/user/center/order_file_list")
    },
    //用户通知
    logstatus() {
        return http.get(apiCfg.portalApi+"/user/center/order_logstatus_list")
    },
    //查询交易订单
    findList( params) {
        return http.get(apiCfg.portalApi+"/order/transactionRecord/list", params)
    },
    // 查看交易明细
    detailList(params) {
        return http.get(apiCfg.portalApi+"/order/transactionRecord/detail", params)
    },
    //查询参数GET /manager/api/1.0/sys/param/list
    listParams(params) {
        return http.get( apiCfg.managerApi+ "/sys/param/list",params)
    },
    // 登录客户参数（按服务市场过滤 fbacode/海外仓）
    listUserParams(params) {
        return http.get(apiCfg.portalApi + "/user/param/list", params)
    },
    // 客户可用渠道（按登录客户类型过滤适用客户；下单选渠道）
    listChannelForCustomer(params) {
        return http.get(apiCfg.portalApi + "/price/channel/list", params)
    },
    // 查价（智能比价，兼容旧 GET /price 结构）
    findPriceForCustomer(params) {
        return http.get(apiCfg.portalApi + "/price", params)
    },
    // 查看送货地
    getPort(params) {
        return http.get(apiCfg.portalApi+"/order/getPort", params)
    },
    // 智能查价
    smartQuote(params) {
        return http.get(apiCfg.portalApi + "/price/smart", params)
    },
    // 客户可用对外渠道列表
    listPublicChannelForCustomer(params) {
        return http.get(apiCfg.portalApi + "/price/channel/public/list", params)
    },
    // 渠道送货配置（不含真地址）
    channelDispatchConfig(params) {
        return http.get(apiCfg.portalApi + "/price/channel/dispatchConfig", params)
    },
    //下单
    addOrder(params) {
        return http.post(apiCfg.portalApi+"/order/add", params)
    },
    //快捷下单(查价快速下单,仿管理端快捷下单,宽松校验)
    addQuick(params) {
        return http.post(apiCfg.portalApi + "order/addQuick", params)
    },
    //订单货箱列表(箱↔面单号+轨迹)
    listOrderBox(params) {
        return http.get(apiCfg.portalApi+"/order/box/list", params)
    },
    //取消订单
    cancel(params) {
        return http.post(apiCfg.portalApi+"/order/cancel", params)
    },
    //修改客户密码
    updatePass(params) {
        return http.post(apiCfg.portalApi+"/user/updatePassword", params)
    },
    //删除客户的供应商/发货人/进口商
    updateUser(params) {
        return http.post(apiCfg.portalApi+"/user/userInfo/del", params)
    },
    //快捷登录
    fastLogin(params) {
        return http.post(apiCfg.portalApi+"/fast_login", params)
    },
    //查询公共订单
    search(params){
        return http.get(apiCfg.portalApi+"/searchOrder",params)
    },
    /** 首页船名定位（飞驼网页账号，客户免费） */
    vesselLocate(params){
        return http.get(apiCfg.portalApi+"/user/vesselLocate", params)
    },
    queryMMSI(params){
        return http.get(apiCfg.portalApi+"/user/queryMMSI", params)
    },
    //客户新增收款申请
    submitPayment(params){
        return http.post(apiCfg.portalApi+"/order/submitPayment",params)
    },
    //客户实名认证
    userAuthe(params){
        return http.get(apiCfg.portalApi+"/user/userAuthe",params)
    },
    bindingWeixin(params){
        return http.get(apiCfg.portalApi+"/user/bindingWeixin",params)
    },
    unbindWeixin(params){
        return http.get(apiCfg.portalApi+"/user/unbindWeixin",params)
    },
    getTimeData(params){
        return http.get(apiCfg.portalApi+"/order/getTimeData",params)
    },
    // TODO(C): 下列 managerApi 仍被业务页使用，待 Portal 代理齐全后迁走并去掉 mApi
    getTracking(params){
        return http.get( apiCfg.managerApi+ "/report/getTracking",params)
    },
    setCreate(params){
        return http.get(apiCfg.managerApi+ "/report/setCreate",params)
    },
    // 修改订单1
    update1(params){
        return http.post(apiCfg.portalApi+"/order/update1", params)
    },
    //新增订单文件
    addFile(params) {
        return http.post(apiCfg.portalApi+"/order/file/add", params)
    },
    // 修改订单2
    update2(params){
        return http.post(apiCfg.portalApi + "order/update2", params)
    },
    goodsRiskCheck(params){
        return http.post(apiCfg.portalApi+"/order/assist/goodsRiskCheck", params)
    },
    productSuggest(params){
        return http.post(apiCfg.portalApi+"/order/assist/productSuggest", params)
    },
    // 下单助手：同渠道最近一票可复用默认值
    lastOrderDefaults(params){
        return http.get(apiCfg.portalApi+"/order/assist/lastDefaults", params)
    },
     //查询尾程柜子
    findWContaienr(params){
        return http.get(apiCfg.managerApi+ "/wc/container/list",params);
    },
    // 拖车服务：上传单据
    trailerUpload(formData){
        return http.post(apiCfg.portalApi + "/order/trailer/upload", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    },
    // 拖车服务：提交
    trailerSubmit(params){
        return http.post(apiCfg.portalApi + "/order/trailer/submit", params);
    },
    // 拖车服务：确认时间 / 补传放行
    trailerConfirm(params){
        return http.post(apiCfg.portalApi + "/order/trailer/confirm", params);
    },
    // 拖车服务：我的列表
    trailerList(params){
        return http.get(apiCfg.portalApi + "/order/trailer/list", params);
    },
       //查询柜子物流日志
    containerLogistics(params){
        return http.get(apiCfg.managerApi+ "/container/find/containerLogistics", params)
    },
      //柜子详情
    cabView( params) {
        return http.get(apiCfg.managerApi+ "/container/view", params)
    },
       //柜子里面尾程订单
    contOrderList(params) {
        return http.get(apiCfg.managerApi+ "/order/tail/container/list", params)
    },
    //批量下载唛头
    mtBDown(params){
        return http.post(apiCfg.managerApi+"/report/mai_tou3_Btach", params,{
            responseType: 'arraybuffer', // 确保拼写正确，且位置正确 
          })
    },

    downloadTemp() {
        return http.get(apiCfg.managerApi+ "/file/template",{
            responseType: 'blob', // 确保拼写正确，且位置正确 
          })
    },
}